import {
  GetPluginDetail,
  getPluginDetail,
  getPluginList,
  GetPluginList,
  getTargetList,
  PostCreateTask,
  postCreateTask,
  UpdatePluginDetail,
  updatePluginDetail,
  getAttCkList,
  getGlobalParam,
  UpdateGlobalParam,
  updateGlobalParam,
  getAttackTypeList,
  getDevices,
  getPluginAmounts,
  GetDownloadDependEnvs,
  getDownloadDependEnvs,
  GetTemplateList,
  getTemplateList,
  GetPluginAmounts,
  getListenerInstallCmd,
  getReverseShellParam,
  getAutoListenerIp,
  updateReverseShellParam,
  getTagTreeOptions,
} from '@/api/endpoint-security/create'
import { getTaskGroups } from '@/api/account-center/task-management'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'

// 客户端列表
export const useGetTargetList = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getTargetList(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取客户端列表失败')
    },
  })
  return [run, data?.data?.items || [], loading] as const
}

// 获取att&ck列表
export const useGetAttCkList = () => {
  const { data } = useRequest(() => getAttCkList(), {
    onError: (err: any) => {
      Message.error(err?.msg || '获取att&ck列表失败')
    },
  })
  return [data?.data?.items || []] as const
}

// 获取全局参数
export const useGetGlobalParam = () => {
  const { runAsync: run, data } = useRequest(() => getGlobalParam(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取全局参数失败')
    },
  })
  return [run, data?.data?.global_param || []] as const
}

// 修改全局参数
export const useUpdateGlobalParam = () => {
  const { runAsync: run, loading } = useRequest((data: any) => updateGlobalParam(data), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '修改全局参数失败')
    },
  })
  return [run, loading] as const
}

// 模板列表
interface GetTemplateListProps {
  getTemplateListParams: GetTemplateList
}
export const useGetTemplateList = (props: GetTemplateListProps) => {
  const { getTemplateListParams } = props
  const { runAsync: run, data } = useRequest(() => getTemplateList(getTemplateListParams), {
    refreshDeps: [getTemplateListParams],
    onError: (err: any) => {
      Message.error(err?.msg || '获取模板列表失败')
    },
  })
  return [run, data?.data || {}] as const
}
// 插件列表
interface GetPluginListProps {
  getPluginListParams: GetPluginList
}
export const useGetPluginList = () => {
  // const { getPluginListParams } = props
  const { runAsync: run, data } = useRequest(params => getPluginList(params), {
    // refreshDeps: [getPluginListParams],
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取插件列表失败')
    },
  })
  return [run, data?.data || {}] as const
}

// 插件详情
export const useGetPluginDetail = () => {
  const { runAsync: run, data } = useRequest((datas: GetPluginDetail) => getPluginDetail(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取插件详情失败')
    },
  })
  return [run, data?.data || {}] as const
}

//  修改插件参数
export const useUpdatePluginDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (datas: UpdatePluginDetail) => updatePluginDetail(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || '修改插件参数失败')
      },
    },
  )
  return [run, loading] as const
}

//  创建任务
export const usePostCreateTask = () => {
  const { runAsync: run, loading } = useRequest((datas: PostCreateTask) => postCreateTask(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '创建任务失败')
    },
  })
  return [run, loading] as const
}

//  获取攻击类型
export const useGetAttackTypeList = () => {
  const { runAsync: run, data } = useRequest(() => getAttackTypeList(), {
    manual: false,
    onError: (err: any) => {
      Message.error(err?.msg || '获取攻击类型失败')
    },
  })
  return [run, data?.data?.items || []] as const
}

//  获取安全设备
export const useGetDevices = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getDevices(), {
    // manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取安全设备失败')
    },
  })
  return [run, data?.data || {}, loading] as const
}
//  插件数量（攻击类型&&依赖环境）
export const useGetPluginAmounts = () => {
  const { runAsync: run, data } = useRequest(
    (params: GetPluginAmounts) => getPluginAmounts(params),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || '获取失败')
      },
    },
  )
  return [run, data?.data?.items || []] as const
}

// 下载环境依赖包
export const useGetDownloadDependEnvs = () => {
  const { runAsync: run } = useRequest(
    (data: GetDownloadDependEnvs) => getDownloadDependEnvs(data),
    {
      manual: true,
      onError: (err: any) => {
        // Message.error(err?.msg || '获取失败')
      },
    },
  )
  return [run] as const
}

// 获取listener安装命令
export const useGetListenerInstallCmd = () => {
  const { data, runAsync: run } = useRequest(() => getListenerInstallCmd(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取listener安装命令失败')
    },
  })

  return [data?.data?.command || '', run] as const
}

// 获取反弹shell参数
export const useGetReverseShellParams = () => {
  const { data, runAsync: run } = useRequest(() => getReverseShellParam(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取反弹shell参数失败')
    },
  })

  return [data?.data || {}, run] as const
}

// 获取自动监听listener ip
export const useGetAutoListenerIp = () => {
  const { runAsync: run } = useRequest(() => getAutoListenerIp(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取自动监听listener ip失败')
    },
  })

  return [run] as const
}

// 更新反弹shell参数
export const useUpdateReverseShellParams = () => {
  const { runAsync: run, loading } = useRequest((data: any) => updateReverseShellParam(data), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '更新反弹shell参数失败')
    },
  })

  return [run, loading] as const
}

// 创建任务tag
export const useGetTagTreeOptions = () => {
  const { runAsync: run, data } = useRequest(params => getTagTreeOptions(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '获取标签列表失败')
    },
  })
  console.log('data', data)
  return [run, data?.data?.categoryList || []] as const
}

// 获取任务分组
export const useTaskGroup = () => {
  const { data, runAsync: run } = useRequest(params => getTaskGroups(params), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || '获取任务分组列表失败')
    },
  })
  return [data?.data?.groups || [], run] as const
}
